var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgHandymanServicesIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 102,
    height: 102,
    viewBox: "0 0 102 102",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_dii_4857_1718)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M50.7451 0.248352C23.1351 0.248352 0.745132 22.6384 0.745132 50.2484C0.745132 77.8584 23.1351 100.248 50.7451 100.248C78.3551 100.248 100.745 77.8584 100.745 50.2484C100.745 22.6384 78.3551 0.248352 50.7451 0.248352ZM6.74513 50.2484C6.74513 25.9884 26.4851 6.24835 50.7451 6.24835C65.9551 6.24835 79.3851 14.0084 87.2851 25.7684L76.9351 35.7784C76.0051 36.4484 74.2851 38.2484 73.0651 38.0884C72.4351 37.9984 71.5251 37.5084 70.8351 37.3384C68.1951 36.6984 61.4051 36.7584 58.5551 36.9784C56.9851 37.0984 55.9151 37.7584 54.6151 38.5684C52.9951 39.5884 47.1751 43.4384 46.3251 44.7284C45.9851 45.2484 45.7851 45.9384 45.7251 46.5584C45.4551 49.5284 45.7651 53.1584 45.7351 56.2084C45.7251 56.6084 45.5551 56.9984 45.5751 57.4684C45.6451 59.7284 47.6451 60.4684 49.6051 60.2284C53.5051 59.7484 55.1251 53.2684 54.8051 50.0384C55.8951 50.1584 56.8251 49.8884 57.8051 49.4284C58.1751 49.2684 59.3151 48.4384 59.5251 48.4984C63.3751 51.9484 66.9451 55.7384 72.5951 55.2884C73.6851 55.1984 74.7251 54.7684 75.7851 54.5684C74.6151 56.1084 72.5751 56.8884 70.6751 56.8484C71.4051 57.9584 71.8451 59.3484 71.5251 60.6684C75.6351 59.6384 79.1751 63.3384 77.9251 67.3884L79.5451 69.1884C82.4351 66.8484 84.9451 64.2284 86.4451 60.7784C88.0951 56.9984 87.5551 56.6284 90.8951 53.7284C92.1251 52.6484 93.4351 51.6584 94.7251 50.6384C94.6351 60.7684 91.1051 70.0884 85.2451 77.4984L77.1351 68.8984L68.2551 77.7584L75.4551 85.9483L75.8251 86.3684C68.7051 91.3384 60.0551 94.2584 50.7351 94.2584C26.4751 94.2584 6.73513 74.5184 6.73513 50.2584L6.74513 50.2484Z",
    fill: "#00FFFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.1651 45.8484C44.1651 44.7384 45.4151 43.2184 46.2151 42.5084C47.8951 41.0284 50.0751 39.8784 51.8151 38.4684L45.8651 32.1483L46.7751 31.2984C48.5651 28.8384 44.5551 27.3584 44.5951 24.7984C44.6351 22.3284 49.1451 20.3084 51.1751 19.7684C55.1351 18.7184 58.7251 19.2984 62.6251 20.2684C62.6951 19.8784 62.5851 19.7484 62.3351 19.4884C61.7051 18.7984 59.0551 17.3984 58.0951 16.9284C50.0151 12.9784 40.5051 13.4584 33.5851 19.4384C33.5851 19.4384 25.8451 25.7584 25.7151 26.2884C25.1451 27.1284 23.8451 27.7484 23.8051 28.8684C23.7651 29.7684 24.5651 30.4284 24.7151 31.2284C25.2551 34.1184 22.5751 36.8084 19.7051 35.6384C18.6651 35.2184 18.2451 34.1384 16.8451 34.7184C15.8951 35.7584 12.3251 38.2684 12.1351 39.5284C12.0051 40.3784 12.3051 40.9184 12.7951 41.5584C15.3251 44.8684 19.4151 47.8084 21.9951 51.1784C23.7951 52.6584 24.7751 51.5384 26.1751 50.3084C26.6551 49.8884 28.7651 47.8384 28.9051 47.4084C29.4151 45.7984 26.9851 44.5184 28.5651 41.8284C29.6151 40.0384 31.5751 39.6484 33.4551 40.3284C34.5251 40.7084 34.9051 41.6284 36.3251 41.0584L36.8751 40.5384L44.1451 48.3284V45.8484H44.1651Z",
    fill: "#00FFFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M69.8451 61.1684C70.7751 58.4584 68.5051 55.8584 65.6851 56.2984C65.0651 56.3984 64.3551 56.7884 63.8751 57.1884L53.8851 67.0583C51.8751 70.4983 55.9251 74.0884 59.1851 71.9284C61.3251 69.7684 63.6351 67.7683 65.7951 65.6283C66.7451 64.6883 69.4751 62.2484 69.8451 61.1684Z",
    fill: "#00FFFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M76.3651 66.9784C77.2951 64.4084 75.2451 61.7584 72.4951 62.1184C71.8151 62.2084 71.2051 62.5784 70.6851 62.9984C67.4351 65.6184 64.3851 69.5784 61.1851 72.3584C59.4051 75.2884 62.2551 78.6384 65.4351 77.6084C66.6351 77.2184 70.5951 73.1584 71.7551 72.0084C72.8251 70.9484 75.9351 68.1584 76.3651 66.9784Z",
    fill: "#00FFFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M61.9551 56.8284C63.7251 54.2884 61.8551 50.7484 58.7451 50.9084C58.1751 50.9384 56.6751 51.4784 56.4351 52.0084C56.2851 52.3384 56.2651 53.5984 56.1551 54.1384C55.1251 59.0484 52.2551 62.7984 46.8251 61.4684C46.3951 61.3584 46.2151 62.2184 46.1651 62.5884C45.7551 65.7884 49.2151 68.0884 51.9851 66.4284C52.6051 66.0584 53.9651 64.6584 54.5951 64.0684C57.0951 61.7184 59.4951 59.2184 61.9551 56.8184V56.8284Z",
    fill: "#00FFFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.1651 50.4584C43.9151 50.3984 43.8851 50.5584 43.7351 50.6684C43.0351 51.1984 39.7551 54.5284 39.4551 55.1784C37.9951 58.4084 41.6351 61.9584 44.7251 60.0184C43.1751 57.2184 44.5151 53.5484 44.1551 50.4584H44.1651Z",
    fill: "#00FFFF"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_dii_4857_1718",
    x: -0.00000339746,
    y: -0.0000265539,
    width: 101.49,
    height: 102.32,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 0.496757
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.372568
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.4 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "screen",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_4857_1718"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_4857_1718",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 2.07148
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.86284
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.4 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "multiply",
    in2: "shape",
    result: "effect2_innerShadow_4857_1718"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1.07796
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.24189
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "soft-light",
    in2: "effect2_innerShadow_4857_1718",
    result: "effect3_innerShadow_4857_1718"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHandymanServicesIcon);
export default __webpack_public_path__ + "static/media/HandymanServicesIcon.14dcf5f2ecd723e95f5de0c60dc44986.svg";
export { ForwardRef as ReactComponent };